module.exports = __webpack_public_path__ + "img/risk.1c22f35b.svg";